<template>
  <InfoCard
    class="base-info-container"
    icon="iconfont iconExperience"
    :title="$t(`${i18nPrefix}.title.${ isPartTime ? 'partTimeExperience' : 'workExperience' }`)"
    :infoList="infoList"
    :infoLines="infoLines"
  >
  </InfoCard>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import InfoCard from '@/components/candidate/infoCard.vue'
import { addI18nProperty, getI18nPropertyValue } from '@/i18n'
import { formatBigNumber } from '@/components/filters'

export default {
  components: {
    InfoCard
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    isPartTime: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.profile'
    }
  },
  computed: {
    infoLines () {
      const i18nPrefix = this.i18nPrefix
      const lines = {
        company_name: {
          labelI18nKey: `${i18nPrefix}.label.companyName`
        },
        job_title: {
          labelI18nKey: `${i18nPrefix}.label.jobTitle`
        },
        industry: {
          labelI18nKey: `${i18nPrefix}.label.industry`,
          formatter: (val, info) => info.industry?.i18nName
        },
        location: {
          labelI18nKey: `${i18nPrefix}.label.location`,
          formatter: this.formatLocation
        },
        date: {
          labelI18nKey: `${i18nPrefix}.label.date`,
          formatter: this.formatWorkTime,
          multipleText: true
        },
        salary: {
          labelI18nKey: `${i18nPrefix}.label.salary`,
          formatter: (val, info) => {
            const currency = info.currency && info.currency !== '---' ? `(${info.currency})` : ''
            return `${formatBigNumber(info.salary) || ''} ${currency}`
          }
        },
        summary: {
          labelI18nKey: `${i18nPrefix}.label.description`,
          multipleText: true,
          fullLine: true
        }
      }
      return lines
    },
    infoList () {
      return _.map(this.dataList, item => {
        addI18nProperty(item.industry, 'i18nName', 'cn_name', 'name')
        return item
      })
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    formatLocation (location, info) {
      if (!location) {
        return
      }
      return _.chain(['country', 'province', 'city']).map(key => {
        const val = _.get(location, key)
        if (!val) {
          return
        }
        return getI18nPropertyValue(val, 'cn_name', 'name')
      }).filter().reverse().join(' ').value()
    },
    formatWorkTime (val, info) {
      const startDate = info.start_date
      const endDate = info.end_date
      if (!startDate) {
        return
      }
      const startMoment = moment(startDate)
      const endMoment = endDate && moment(endDate)
      const startDateStr = startMoment.format('YYYY.MM.DD')
      const endDateStr = endDate ? endMoment.format('YYYY.MM.DD') : this.$t(`${this.i18nPrefix}.label.now`)
      const workTime = `${startDateStr} - ${endDateStr}`
      if (endDate) {
        const duration = moment.duration(endMoment.diff(startMoment))
        const durationStr = _.chain(['years', 'months', 'days']).map(key => {
          let dateI18nKey = key
          const dateNum = duration.get(key)
          if (!dateNum) {
            return
          }
          if (dateNum === 1) {
            dateI18nKey = key.replace('s', '')
          }
          return this.$t(`${this.i18nPrefix}.label.dates.${dateI18nKey}`, { num: dateNum })
        }).filter().join(' & ').trim().value()
        return `${workTime}\n(${durationStr})`
      }
      return workTime
    }
  }
}
</script>

<style lang="scss" scoped>
.base-info-container {
  .detail-item {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    margin-top: 16px;

    &:nth-child(1), &:nth-child(2) {
      margin-top: 0;
    }

    .label {
      font-weight: bold;
      line-height: 20px;
    }

    .content {
      color: #606266;
    }
  }

  .description {
    width: 100%;
  }

  ::v-deep {
    .card-title-container {
      .title {
        color: #303133;
        font-weight: 500;
      }

      .title-icon {
        font-size: 26px;
      }
    }

    .card-list {
      .info-line-list {
        .info-line {
          .info-label {
            font-weight: 500;
          }
        }
      }

      .info-card {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }
}
</style>
